import lodash from 'lodash'

export default {
	addConfigAndFeatureVariables(app, customConfig, defaultConfig={}) {
		const config = lodash.merge(defaultConfig, customConfig)
		
		app.config.globalProperties.CONFIG 	= config.CONFIG || null
		app.config.globalProperties.FEATURE = config.FEATURE || null
	}
}